<template>
  <section>
    <h2 class="text-center">Ban Visitor</h2>

    <!-- Start Date -->
    <div class="form-group">
      <label>Start Date</label>
      <b-form-datepicker
        v-model="createBanDto.start_date"
        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        today-button reset-button close-button
        @input="createBanDto.end_date = null"
      />
    </div>

    <!-- End Date -->
    <div class="form-group">
      <label>End Date</label>
      <b-form-datepicker
        v-model="createBanDto.end_date"
        :min="createBanDto.start_date"
        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        today-button reset-button close-button
      />
    </div>

    <!-- Reason -->
    <div class="form-group">
      <label for="reason">Reason</label>
      <textarea
        id="reason"
        class="form-control"
        v-model="createBanDto.reason"
      ></textarea>
    </div>

    <!-- Explanation -->
    <small>
      The visitor will be unable to take part in visits
      for the duration of this ban
    </small>

    <b-btn
      :disabled="!banValid()"
      @click="addBan()"
      class="full-width mt-1" variant="success"
    >
      Add Ban
    </b-btn>
  </section>
</template>

<script>
  import VisitorService from '@/services/VisitorService';
  import {logger} from '@/util/logger';

  export default {
    name: 'add-ban',
    props: {
      visitor_user_id: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        createBanDto: {
          user_id: this.visitor_user_id,
          reason: '',
          start_date: null,
          end_end: null,
        },
      };
    },
    methods: {
      banValid() {
        if(!this.createBanDto.user_id || this.createBanDto.user_id.length < 1) {
          return false;
        }
        if(!this.createBanDto.start_date) {
          return false;
        }
        if(!this.createBanDto.end_date) {
          return false;
        }
        return true;
      },
      addBan() {
        if(!this.banValid()) {
          this.$toast.info('Please check you have filled all the fields out correctly');
          return;
        }

        VisitorService.createBan(this.createBanDto).then(res => {
          this.$toast.success('Added ban successfully!', {
            toastClassName: ['toast-std', 'success-toast'],
          });
          this.close();
        }).catch(err => {
          logger.error('Error creating ban', err, null, 'AddBan:addBan');
          this.$toast.error('Error creating ban. Please try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>
